import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { TipoUsuario } from '../../types';

const NotFound: React.FC = () => {
  const navigate = useNavigate();
  const { isAuthenticated, user } = useAuth();

  const handleVoltar = () => {
    if (!isAuthenticated) {
      navigate('/login', { replace: true });
    } else if (user?.tipo === TipoUsuario.Administrador) {
      navigate('/admin/estabelecimentos', { replace: true });
    } else {
      navigate('/dashboard', { replace: true });
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 flex items-center justify-center p-4">
      <div className="text-center max-w-md">
        <div className="text-8xl font-bold text-gray-200 mb-2 select-none">404</div>

        <div className="text-5xl mb-6">🍰</div>

        <h1 className="text-2xl font-bold text-gray-800 mb-2">
          Página não encontrada
        </h1>
        <p className="text-gray-500 mb-8">
          A página que você está procurando não existe.
        </p>

        <button
          onClick={handleVoltar}
          className="inline-flex items-center gap-2 bg-blue-600 hover:bg-blue-700 text-white font-medium px-6 py-3 rounded-lg transition-colors"
        >
          <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
            <path fillRule="evenodd" d="M9.707 16.707a1 1 0 01-1.414 0l-6-6a1 1 0 010-1.414l6-6a1 1 0 011.414 1.414L5.414 9H17a1 1 0 110 2H5.414l4.293 4.293a1 1 0 010 1.414z" clipRule="evenodd" />
          </svg>
          Voltar para o início
        </button>
      </div>
    </div>
  );
};

export default NotFound;
